import { DetailsList, DetailsRow, Stack, ScrollablePane, ScrollbarVisibility, PrimaryButton, TextField, SelectionMode, Selection, DetailsListLayoutMode, DefaultButton, Text, TeachingBubble, IconButton } from 'office-ui-fabric-react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { mutationPerformManualMuting, mutationCreateManualMuteSequence, mutationDeleteManualMuteSequences, queryGetEntry } from "../../../../../queries/queryRecordings";
import React, { Component } from 'react'
import { MyContext } from '../../../../../context';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { Persona, PersonaSize, PersonaPresence } from 'office-ui-fabric-react/lib/Persona';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import './CleanUp.scss';
import { Spinner, SpinnerSize } from '@fluentui/react';

export default class CleanUp extends React.Component {


    constructor(props) {
        super(props);

        let columns = [

            {
                key: 'isActive',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "executed")}</>)}</MyContext.Consumer>,
                fieldName: 'isActive',
                isResizable: true,
                data: 'boolean',
                minWidth: 80,
                maxWidth: 80,
                onRender: (item, index, column) => (
                    <span>{item.isActive ? 'Yes' : 'No'}</span>
                ),
            },

            {
                key: 'startTime',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "start")}</>)}</MyContext.Consumer>,
                fieldName: 'startTime',
                minWidth: 135,
                maxWidth: 200,
                isResizable: true,
                data: 'string',
                onRender: (item, index, column) => (
                    this.state.editableRowIndex === index ? (
                        <div className="field-container">
                            <div className="field-inline">
                                <TextField
                                    value={item.startTime}
                                    onChange={(e, newValue) => this.updateItem(index, 'startTime', newValue)}
                                    placeholder="hh:mm:ss"
                                />
                                <DefaultButton
                                    text="Set Time"
                                    iconProps={{ iconName: 'Play' }}
                                    onClick={() => this.takeSliderValue(index, 'startTime')}
                                    className="button-start-stop"
                                />
                            </div>
                            <span id="startTime" className="error-message"></span>
                        </div>
                    ) : (
                        <span>{item.startTime}</span>
                    )
                ),
            },
            {
                key: 'stopTime',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "stop")}</>)}</MyContext.Consumer>,
                fieldName: 'stopTime',
                isResizable: true,
                data: 'string',
                minWidth: 135,
                maxWidth: 200,
                onRender: (item, index, column) => (
                    this.state.editableRowIndex === index ? (
                        <div className="field-container">
                            <div className="field-inline">
                                <TextField
                                    value={item.stopTime}
                                    onChange={(e, newValue) => this.updateItem(index, 'stopTime', newValue)}
                                    placeholder="hh:mm:ss"
                                />
                                <DefaultButton
                                    text="Set Time"
                                    iconProps={{ iconName: 'Play' }}
                                    onClick={() => this.takeSliderValue(index, "stopTime")}
                                    className="button-start-stop"
                                />
                            </div>
                            <span id="stopTime" className="error-message"></span>
                        </div>
                    ) : (
                        <span>{item.stopTime}</span>
                    )
                ),
            },
            {
                key: 'createdAt',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "mutedOn")}</>)}</MyContext.Consumer>,
                fieldName: 'createdAt',
                isResizable: true,
                data: 'string',
                minWidth: 150,
                maxWidth: 200,

                onRender: (item) => {
                    const date = new Date(item.createdAt);
                    const formattedDate = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
                    return <span>{formattedDate}</span>;
                },
            },
            {
                key: 'createdByUserId',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "mutedBy")}</>)}</MyContext.Consumer>,
                fieldName: 'createdByUserId',
                isResizable: true,
                data: 'string',
                minWidth: 70,
                maxWidth: 150,
                onRender: (item) => (

                    <TooltipHost content={item.createdByUserName}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Persona key={item.createdByUserId} size={PersonaSize.size24} text={item.createdByUserName} />
                        </div>
                    </TooltipHost>

                ),
            },
            {
                key: 'reason',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "note")}</>)}</MyContext.Consumer>,
                fieldName: 'reason',
                isResizable: true,
                data: 'string',
                minWidth: 100,
                maxWidth: 350,

                onRender: (item, index, column) => (
                    this.state.editableRowIndex === index ? (
                        <TextField
                            value={item.reason}
                            onChange={(e, newValue) => this.updateItem(index, 'reason', newValue)}
                        />
                    ) : (
                        <span>{item.reason}</span>
                    )
                ),
            },
            {
                key: 'addSequence',
                name: "",
                fieldName: 'addSequence',
                minWidth: 70,
                maxWidth: 100,
                isResizable: true,
                onRender: (item, index) => {
                    return this.state.editableRowIndex === index ? (
                        <PrimaryButton
                            text="Save"
                            onClick={() => this.confrimAddMute()}
                            style={{ height: "32px" }}
                        />
                    ) : null;
                }
            }

        ];




        this.state = {
            columns: columns,
            items: this.props.data.manualMuteSequences,
            selectedItems: [],
            editableRowIndex: null,
            performMessageError: "",
            confirmPerformAction: false,
            graphqlCallPending: false

        };


    }

    componentDidUpdate(prevProps) {
        if (prevProps.data.manualMuteSequences !== this.props.data.manualMuteSequences) {
            this.setState({
                items: this.props.data.manualMuteSequences,
                graphqlCallPending: false

            });
        }
    }

    validateTime = (value, field, index) => {
        const timePattern = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
        let errorMessage = '';

        if (!timePattern.test(value)) {
            errorMessage = 'Invalid time format. Please use hh:mm:ss';
        } else {
            const [hours, minutes, seconds] = value.split(':').map(Number);
            const totalSeconds = hours * 3600 + minutes * 60 + seconds;
            const callDurationInSeconds = this.convertTimeToSeconds(this.props.data.duration);
            if (totalSeconds > callDurationInSeconds) {
                errorMessage = 'Time exceeds the recording duration';
            } else {
                const items = [...this.state.items];
                if (field === 'stopTime' && totalSeconds <= this.convertTimeToSeconds(items[index].startTime)) {
                    errorMessage = 'Stop time must be greater than start time';
                } else if (field === 'startTime' && items[index].stopTime && totalSeconds >= this.convertTimeToSeconds(items[index].stopTime)) {
                    errorMessage = 'Start time must be less than stop time';
                }
            }
        }

        const errorMessageField = document.getElementById(field);
        if (errorMessageField) {
            errorMessageField.textContent = errorMessage;
            errorMessageField.style.color = errorMessage ? 'red' : 'inherit';
        }

        return errorMessage;
    };

    convertTimeToSeconds = (time) => {
        const [hours, minutes, seconds] = time.split(':').map(Number);
        return hours * 3600 + minutes * 60 + seconds;
    };
    convertSecondsToHHMMSS = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return [hours, minutes, secs]
            .map(v => v < 10 ? "0" + v : v)
            .join(":");
    };

    takeSliderValue = (index, field) => {
        const items = [...this.state.items];
        items[index][field] = this.convertSecondsToHHMMSS(this.props.sliderTimeValue);
        this.setState({ items });
    };



    _selection = new Selection({
        onSelectionChanged: () => {
            this.setState({
                selectionDetails: this._selection.getSelection() || []
            });
        },
        canSelectItem: (item) => !item.isActive
    });

    delKeylist = async () => {
        const { items, selectionDetails } = this.state;
        if (!selectionDetails || selectionDetails.length === 0) {
            this.setState({ performMessageError: "noItemSelected" });
            return;
        } else {
            this.setState({ graphqlCallPending: true });//disable add/delete buttons untill final list is updated from graphql

            const manualMutes = selectionDetails.map(item => ({
                isActive: item.isActive,
                startTime: item.startTime,
                stopTime: item.stopTime,
                createdAt: item.createdAt,
                createdByUserId: item.createdByUserId,
                reason: item.reason,
                startId: item.startId,
                stopId: item.stopId
            }));
            var data = await this.props.client
                .mutate({
                    mutation: mutationDeleteManualMuteSequences,
                    refetchQueries: [{
                        query: queryGetEntry,
                        variables: { id: this.props.data.conversationId, auth: this.props.data.authorization, callStartMs: this.props.data.callStartMs, isHistoryVault: this.props.data.isHistoryVault }
                    }],
                    variables: {
                        conversationId: this.props.data.conversationId,
                        tenantId: this.props.data.tenantId,
                        manualMutes: manualMutes
                    }
                });

            if (!data || !data.data || !data.data.deleteManualMuteSequences || data.data.deleteManualMuteSequences.length === 0) {
                this.setState({ graphqlCallPending: false });
            }

            const updatedItems = items.filter(item => !selectionDetails.includes(item));

            this.setState({
                items: updatedItems,
                selectionDetails: undefined,
                editableRowIndex: null,
                updated: true
            });
        }

    }

    updateItem = (index, field, value) => {
        const items = [...this.state.items];
        items[index][field] = value;
        this.setState({ items });
    };

    addMuteToList = () => {

        const newItem = {
            isActive: false,
            startTime: '',
            stopTime: '',
            createdAt: new Date().toISOString(),
            createdByUserId: this.props.userRules.userId,
            createdByUserName: "Current User",
            reason: '',
            startId: "",
            stopId: ""
        };
        const newItems = [...this.state.items, newItem];
        this.setState({
            items: newItems,
            editableRowIndex: newItems.length - 1
        });
    };
    confrimAddMute = async () => {

        const { items, editableRowIndex } = this.state;
        const startTime = items[editableRowIndex].startTime;
        const stopTime = items[editableRowIndex].stopTime;

        const startTimeError = this.validateTime(startTime, 'startTime', editableRowIndex);
        const stopTimeError = this.validateTime(stopTime, 'stopTime', editableRowIndex);

        if (startTimeError || stopTimeError) {
            return;
        }

        this.setState({ graphqlCallPending: true });//disable add/delete buttons untill final list is updated from graphql

        var data = await this.props.client
            .mutate({
                mutation: mutationCreateManualMuteSequence,
                refetchQueries: [{
                    query: queryGetEntry,
                    variables: { id: this.props.data.conversationId, auth: this.props.data.authorization, callStartMs: this.props.data.callStartMs, isHistoryVault: this.props.data.isHistoryVault }
                }],
                variables: {
                    conversationId: this.props.data.conversationId,
                    tenantId: this.props.data.tenantId,
                    manualMute: {
                        isActive: this.state.items[this.state.editableRowIndex].isActive,
                        startTime: this.state.items[this.state.editableRowIndex].startTime,
                        stopTime: this.state.items[this.state.editableRowIndex].stopTime,
                        createdAt: new Date().toISOString(),
                        createdByUserId: this.state.items[this.state.editableRowIndex].createdByUserId,
                        reason: this.state.items[this.state.editableRowIndex].reason,
                        startId: this.state.items[this.state.editableRowIndex].startId,
                        stopId: this.state.items[this.state.editableRowIndex].stopId
                    }
                }
            });

        this.setState({
            editableRowIndex: null
        }, () => {
            this._selection.setAllSelected(false);
        });
    }

    onDismissPerform = () => {
        this.setState({ confirmPerformAction: false });
    };
    onDismisMessageBar = () => {
        this.setState({ performMessageError: false });
    };
    openPerformBubble = () => {
        this.setState({ confirmPerformAction: true });
    };

    performAction = async () => {
        this.setState({ confirmPerformAction: false });
        const data = await this.props.performAction(this.props.data.conversationId, this.props.data.authorization, this.props.data.callStartMs, this.props.data.tenantId);
        if (data.data.performManualMuting!=="success") {
            this.setState({ performMessageError: data.data.performManualMuting });
        }
    };

    isWithin90Days = (recordingStarts) => {
        if (!recordingStarts) return false;
        const [startDate] = recordingStarts.split('|').map(date => date.trim());
        const recordingDate = new Date(startDate);
        const currentDate = new Date();
        const diffTime = Math.abs(currentDate - recordingDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays <= 90;
    }


    render(): React.ReactNode {
        const { columns, items } = this.state;
        const isWithin90Days = this.isWithin90Days(this.props.data.recordingStarts);

        const buttonStyles = {
            root: {
                display: 'flex',
                alignItems: 'center',
                padding: '0 8px',
                height: '32px',
                border: 'none',

            },
            icon: {
                fontSize: 14,
                marginRight: 8,
            },
        };

        var classNames = mergeStyleSets({
            wrapper: {
                height: this.props.height,
                position: 'relative',
                minHeight: '100px'
            },
            button: {
                margin: '0',
            },
            noSelectionMode: {
                paddingLeft: '48px'
            }


        });
        return (
            <MyContext.Consumer>
                {(context) => (<>
                    {(items.length === 0 && (this.props.userRules.ruleAccess.suspensionConvDelProcess || !this.props.userRules.ruleAccess.allowManualMuting)) ? (
                        <div className="no-cleanup">
                            <Text variant="medium" className="bold-text">
                                {context.getTranslation("detailContainer", "noCleanupPerfomred")}
                            </Text>
                        </div>
                    ) : (<>
                        {this.state.performMessageError &&
                            <MessageBar
                                messageBarType={MessageBarType.error}
                                isMultiline={false}
                                onDismiss={this.onDismisMessageBar}
                                dismissButtonAriaLabel="Close"
                            >
                                {context.getTranslation("detailContainer", this.state.performMessageError)}
                            </MessageBar>}
                        {!(this.props.userRules.ruleAccess.suspensionConvDelProcess || !this.props.userRules.ruleAccess.allowManualMuting) && isWithin90Days && (<>
                            <MessageBar
                                messageBarType={MessageBarType.info}
                                isMultiline={false}
                            >
                                {context.getTranslation("detailContainer", "cleanupInfoMessage")}
                            </MessageBar>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                                <DefaultButton
                                    className={classNames.button}
                                    onClick={this.addMuteToList}
                                    text={context.getTranslation("detailContainer", "addMute")}
                                    iconProps={{ iconName: 'Add' }}
                                    styles={buttonStyles}
                                    disabled={this.state.editableRowIndex !== null || this.state.graphqlCallPending || this.props.graphqlCallPerformPending}
                                />

                                <DefaultButton
                                    className={classNames.button}
                                    iconProps={{ iconName: 'Delete' }}
                                    onClick={this.delKeylist}
                                    styles={buttonStyles}
                                    text={context.getTranslation("detailContainer", "deleteSelected")}
                                    disabled={this.state.graphqlCallPending || this.props.graphqlCallPerformPending}
                                />

                            </Stack>
                        </>)}
                        <br />
                        <div className={classNames.wrapper}>
                            {(this.state.graphqlCallPending || this.props.graphqlCallPerformPending) && (
                                <div className="table-spinner-overlay">
                                    <Spinner size={SpinnerSize.large} label="Loading..." />
                                </div>
                            )}
                            <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                                <Stack tokens={{ childrenGap: 10 }}>
                                    <DetailsList
                                        items={items}
                                        columns={columns}
                                        selectionMode={SelectionMode.multi}
                                        selection={this._selection}
                                        setKey="value"
                                        onRenderRow={(props) => {
                                            if (props) {
                                                const item = props.item;
                                                const customProps = { ...props };
                                                if (item.isActive) {
                                                    customProps.selectionMode = SelectionMode.none;
                                                    customProps.className = `${props.className} no-selection-mode`;
                                                }
                                                return <DetailsRow {...customProps} />;
                                            }
                                            return null;
                                        }}
                                    />
                                    {!(this.props.userRules.ruleAccess.suspensionConvDelProcess || !this.props.userRules.ruleAccess.allowManualMuting) && isWithin90Days && (
                                        <div className="perform-action-container">
                                            <PrimaryButton
                                                id="performAction"
                                                onClick={this.openPerformBubble}
                                                text={context.getTranslation("detailContainer", "execute")}
                                                disabled={this.state.graphqlCallPending || this.props.graphqlCallPerformPending || this.state.items.filter(item => !item.isActive).length === 0}
                                            />
                                            {this.state.confirmPerformAction &&
                                                <TeachingBubble
                                                    target={`#${"performAction"}`}
                                                    secondaryButtonProps={{ children: context.getTranslation("common", "cancel"), onClick: () => { this.setState({ confirmPerformAction: false }) } }}
                                                    primaryButtonProps={{ children: context.getTranslation("common", "execute"), onClick: this.performAction }} onDismiss={this.onDismissPerform}
                                                    headline={context.getTranslation("detailContainer", "confirmAction")}
                                                >
                                                    {context.getTranslation("detailContainer", "confirmMutePerform")}
                                                    {this.state.items.filter(item => item.isActive === false).length > 0 && (
                                                        <div className="confirm-mute-list">
                                                            <ul>
                                                                {this.state.items.filter(item => item.isActive === false).map((item, index) => (
                                                                    <li key={index}>
                                                                        <Text>{context.getTranslation("detailContainer", "start")}: {item.startTime}, {context.getTranslation("detailContainer", "stop")}: {item.stopTime}, {context.getTranslation("detailContainer", "note")}: {item.reason}</Text>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </TeachingBubble>
                                            }
                                        </div>
                                    )}
                                </Stack>
                            </ScrollablePane>
                        </div>
                    </>)}
                </>)}
            </MyContext.Consumer>
        );
    }
}





